'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _actionTypes = require('../constants/actionTypes');

var _AsyncData = require('conversations-async-data/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

var _updateAsyncData = require('conversations-async-data/async-data/operators/updateAsyncData');

var _requestStarted = require('conversations-async-data/async-data/operators/requestStarted');

var _requestSucceededWithOperator = require('conversations-async-data/async-data/operators/requestSucceededWithOperator');

var _setSessionId = require('../operators/setSessionId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _AsyncData2.default({ data: new _WidgetData2.default() });

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.GET_WIDGET_DATA, _requestStarted.requestStarted), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.GET_WIDGET_DATA_SUCCEEDED, _actionTypes.REFRESH_WIDGET_DATA), function (state, action) {
  return (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
    return action.payload;
  }, state);
}), _defineProperty(_handleActions, _actionTypes.UPDATE_SESSION_ID, function (state, action) {
  var sessionId = action.payload.sessionId;

  return (0, _updateAsyncData.updateAsyncData)((0, _setSessionId.setSessionId)(sessionId), state);
}), _handleActions), initialState);
module.exports = exports['default'];